export default "__VITE_ASSET__5fdb85b6__"